import { render, staticRenderFns } from "./AmadeusHotelTourSearch.vue?vue&type=template&id=2548b209&"
import script from "./AmadeusHotelTourSearch.vue?vue&type=script&lang=js&"
export * from "./AmadeusHotelTourSearch.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports